import React from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const Loading = () => (
  <Box width="100%" mb={3} p={3} textAlign="center">
    <Skeleton variant="text" width="50%" />
    <Skeleton variant="text" width="100%" />
    <Skeleton variant="text" width="100%" />
    <Skeleton variant="text" width="80%" />
  </Box>
);

export default Loading;
